
<template>
  <div id="data-list-list-view" class="data-list-container">

    <data-view-sidebar :isSidebarActive="addNewDataSidebar" @closeSidebar="toggleDataSidebar" :data="sidebarData" />

    <vs-table ref="table" pagination :max-items="itemsPerPage" search :data="users">

      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

        <div class="flex flex-wrap-reverse items-center data-list-btn-container">
        </div>

        <!-- ITEMS PER PAGE -->
        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 items-per-page-handler">
          <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
            <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ users.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : users.length }} of {{ queriedItems }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <vs-dropdown-menu>

            <vs-dropdown-item @click="itemsPerPage=5">
              <span>5</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=20">
              <span>20</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=50">
              <span>50</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=100">
              <span>100</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <vs-th sort-key="username">Username</vs-th>
        <vs-th sort-key="email">Email</vs-th>
        <vs-th sort-key="firstname">Firstname</vs-th>
        <vs-th sort-key="lastname">Lastname</vs-th>
        <vs-th sort-key="active">Active</vs-th>
        <vs-th sort-key="twofa_method">2FA</vs-th>
        <vs-th sort-key="password_changed_at">Password age</vs-th>
        <vs-th>Action</vs-th>
      </template>

        <template slot-scope="{data}">
          <tbody>
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

              <vs-td>
                <p class="font-medium truncate">{{ tr.username }}</p>
              </vs-td>

              <vs-td>
                <p>{{ tr.email }}</p>
              </vs-td>

              <vs-td>
                <p>{{ tr.firstname }}</p>
              </vs-td>

              <vs-td>
                <p>{{ tr.lastname }}</p>
              </vs-td>

              <vs-td>
                <vs-chip :color="getActiveColors(tr.isactive)">{{ tr.isactive }}</vs-chip>
              </vs-td>

              <vs-td>
                <vs-chip :color="twofaColor(tr)">
                  <feather-icon :icon="twofaIcon(tr)" svgClasses="w-4 h-4 mr-1" />
                  {{ twofaLabel(tr) }}
                </vs-chip>
              </vs-td>

              <vs-td>
                <vs-chip :color="passwordAgeColor(tr.password_changed_at)" :title="passwordAgeTooltip(tr.password_changed_at)">
                  <feather-icon icon="KeyIcon" svgClasses="w-4 h-4 mr-1" />
                  {{ passwordAgeLabel(tr.password_changed_at) }}
                </vs-chip>
              </vs-td>

              <vs-td class="whitespace-no-wrap">
                <feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" @click.stop="editData(tr)" />
                <feather-icon
                  v-if="tr.twofa_enabled"
                  icon="ShieldOffIcon"
                  svgClasses="w-5 h-5 ml-2 hover:text-danger stroke-current"
                  title="Reset 2FA"
                  @click.stop="confirmResetTwofa(tr)" />
              </vs-td>

            </vs-tr>
          </tbody>
        </template>
    </vs-table>
  </div>
</template>

<script>
import DataViewSidebar from './DataViewSidebar.vue'
import moduleDataListUsers from '@/store/configurations-users/moduleDataList.js'
import twofa from '@/http/requests/auth/twofa.js'

export default {
  components: {
    DataViewSidebar
  },
  data () {
    return {
      selected: [],
      itemsPerPage: 5,
      isMounted: false,
    
      // Data Sidebar
      addNewDataSidebar: false,
      sidebarData: {}
    }
  },
  computed: {
    currentPage () {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },
    users () {
      return this.$store.state.dataListUsers.users
    },
    queriedItems () {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.users.length
    }
  },
  methods: {
  
    editData (data) {
      // this.sidebarData = JSON.parse(JSON.stringify(this.blankData))
      //console.log(optionslanguages)
      this.sidebarData = data
      this.toggleDataSidebar(true)
    }, 
    getActiveColors (status) {
      if (status === true)   return 'primary'
      if (status === false) return 'danger'
      return 'warning'
    },
    twofaLabel (tr) {
      if (!tr.twofa_enabled) return 'Disabled'
      if (tr.twofa_method === 'totp')  return 'Authenticator app'
      if (tr.twofa_method === 'email') return 'Email'
      return 'Enabled'
    },
    twofaColor (tr) {
      if (!tr.twofa_enabled) return 'danger'
      if (tr.twofa_method === 'totp') return 'success'
      return 'primary'
    },
    twofaIcon (tr) {
      if (!tr.twofa_enabled) return 'ShieldOffIcon'
      if (tr.twofa_method === 'totp') return 'SmartphoneIcon'
      return 'MailIcon'
    },
    passwordAgeDays (changedAt) {
      if (!changedAt) return null
      const diffMs = Date.now() - new Date(changedAt).getTime()
      if (Number.isNaN(diffMs) || diffMs < 0) return null
      return Math.floor(diffMs / 86400000)
    },
    passwordAgeLabel (changedAt) {
      const days = this.passwordAgeDays(changedAt)
      if (days === null) return 'Never'
      if (days === 0)    return 'Today'
      if (days === 1)    return '1 day'
      if (days < 30)     return `${days} days`
      if (days < 60)     return '1 month'
      if (days < 365)    return `${Math.floor(days / 30)} months`
      const years = Math.floor(days / 365)
      return years === 1 ? '1 year' : `${years} years`
    },
    passwordAgeColor (changedAt) {
      const days = this.passwordAgeDays(changedAt)
      if (days === null) return 'dark'
      if (days > 365)    return 'danger'
      if (days > 180)    return 'warning'
      return 'success'
    },
    passwordAgeTooltip (changedAt) {
      if (!changedAt) return 'Password has never been changed'
      return `Last changed: ${new Date(changedAt).toLocaleString()}`
    },
    toggleDataSidebar (val = false) {
      this.addNewDataSidebar = val
    },
    confirmResetTwofa (user) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Reset 2FA',
        text: `Disable two-factor authentication for "${user.username}"? They will be asked to set it up again on next login.`,
        accept: () => this.resetTwofa(user),
        acceptText: 'Reset',
        cancelText: 'Cancel'
      })
    },
    resetTwofa (user) {
      twofa.adminResetTwofa(user.id)
        .then(() => {
          this.$vs.notify({
            title: 'Done',
            text: `2FA has been reset for "${user.username}".`,
            iconPack: 'feather',
            icon: 'icon-check',
            color: 'success',
            position: 'bottom-right'
          })
          this.$store.dispatch('dataListUsers/fetchDataListItems')
        })
        .catch((error) => {
          this.$vs.notify({
            title: 'Error',
            text: (error.response && error.response.data && error.response.data.message) || 'Could not reset 2FA.',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger',
            position: 'bottom-right'
          })
        })
    }
  },
  created () {
    if (localStorage.getItem('login-roles').toLowerCase().includes('user')) {
      this.$vs.notify({
        title: 'Denied',
        text: 'Access to the this page is reserved for administrators',
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'danger',
        position: 'bottom-right',
        time: 8000
      })
      this.$router.push({ path: '/dashboard/analytics' })
    } 
    if (!moduleDataListUsers.isRegistered) {
      this.$store.registerModule('dataListUsers', moduleDataListUsers)
      moduleDataListUsers.isRegistered = true
    }
    this.$store.dispatch('dataListUsers/fetchDataListItems')
  },
  mounted () {
    this.isMounted = true
  }
}
</script>

<style lang="scss">
#data-list-list-view {
  .vs-con-table {

    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search{
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr{
          box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
          td{
            padding: 20px;
            &:first-child{
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }
            &:last-child{
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
          }
          td.td-check{
            padding: 20px !important;
          }
      }
    }

    .vs-table--thead{
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text{
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check{
        padding: 0 15px !important;
      }
      tr{
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
